var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3727 7.66955C11.1137 7.17447 11.8917 6.74507 12.6978 6.38407C14.9842 5.36011 16.1275 4.84813 17.6484 5.83348C19.1693 6.81882 19.1693 8.43515 19.1693 11.6678V14.1678C19.1693 17.3105 19.1693 18.8819 20.1456 19.8582C21.1219 20.8345 22.6932 20.8345 25.8359 20.8345H28.3359C31.5686 20.8345 33.1849 20.8345 34.1703 22.3554C35.1556 23.8763 34.6436 25.0195 33.6197 27.306C33.2587 28.1121 32.8293 28.8901 32.3342 29.631C30.5944 32.2348 28.1216 34.2642 25.2284 35.4626C22.3353 36.661 19.1517 36.9745 16.0803 36.3636C13.009 35.7526 10.1878 34.2447 7.97342 32.0303C5.75909 29.816 4.25111 26.9948 3.64018 23.9234C3.02925 20.852 3.3428 17.6685 4.54119 14.7753C5.73957 11.8822 7.76897 9.40934 10.3727 7.66955Z",
    fill: "#84DCC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.746 11.782C34.393 8.34751 31.6554 5.60997 28.221 4.25696C25.6517 3.24481 23.3359 5.57226 23.3359 8.33369V15.0004C23.3359 15.9208 24.0821 16.667 25.0026 16.667H31.6693C34.4307 16.667 36.7581 14.3512 35.746 11.782Z",
    fill: "#1177BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/Pie-chart.bbe8c2f926b4d78ffc91589ddbc7be7a.svg";
export { ForwardRef as ReactComponent };